export default __webpack_public_path__ + "static/media/H1015.1.162d3125.mp3";